import {baseUrl, execute} from "./ApiUtils";


const groupGamesUrl = baseUrl + "groupgame"
const groupGameByIdUrl = baseUrl + "groupgame/"
const cachedGameUrl = baseUrl + "groupgame_cached/"

export function postCreateGroupGame(
    gameName,
    isTrial,
    withVideo,
    selectedStyle,
    players,
    price,
    deckId,
    deckType,
    successCallBack,
    errorCallBack
) {
    execute(() =>
        fetch(groupGamesUrl, {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                game_name: gameName,
                is_trial_game: isTrial,
                video_allowed: withVideo,
                game_field_style_id: selectedStyle,
                players: players.map((player) => {
                    return {
                        name: player.name,
                        is_auto_dice: player.is_auto_dice,
                        chip_char: player.chip_char,
                        chip_color: player.chip_color
                    }
                }),
                price: price,
                deck_id: deckId,
                deck_type: deckType,
            }),
            credentials: "include"
        }), successCallBack, errorCallBack)
}

export function listGroupGames(successCallBack, errorCallBack) {
    execute( () =>
        fetch(groupGamesUrl, {
                method: 'GET',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                },
                credentials: "include"
            }

        ), successCallBack, errorCallBack
    )
}

export function getGroupGame(game_id, player_id, successCallBack, errorCallBack) {
    let url = groupGameByIdUrl + game_id
    if (player_id) {
        url += `?player=${player_id}`
    }
    execute(() => fetch(url,{
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }
    ), successCallBack, errorCallBack)
}

export function postUpdateGroupGame(
    gameId,
    gameName,
    selectedStyle,
    deckId,
    deckType,
    players,
    priceDelta,
    successCallBack,
    errorCallBack) {
    execute(() =>
        fetch(groupGameByIdUrl + gameId, {
            method: 'PATCH',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                game_name: gameName,
                game_field_style_id: selectedStyle,
                deck_id: deckId,
                deck_type: deckType,
                players: players.map((player) => {
                    const player_obj = {
                        status: player.status,
                        name: player.name,
                        is_auto_dice: player.is_auto_dice,
                        chip_char: player.chip_char,
                        chip_color: player.chip_color
                    }
                    if (player.status === "deleted" || player.status === "updated") {
                        player_obj.id = player.id
                    }
                    return player_obj
                }),
                price_delta: priceDelta
            }),
            credentials: "include"
        }), successCallBack, errorCallBack)
}

export function deleteGroupGame(gameId, successCallBack, errorCallBack) {
    execute( () =>
        fetch(groupGameByIdUrl + gameId, {
            method: 'DELETE',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: "include"
            }

        ), successCallBack, errorCallBack
    )
}

export function confirmIdentity(game_id, player_id, successCallBack, errorCallBack) {
    const url = `${groupGameByIdUrl}${game_id}/player/${player_id}/confirm_identity`
    execute(() => fetch(url,{
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }
    ), successCallBack, errorCallBack)
}

export function getAllMentorCardsByGroupGameId(gameId, successCallBack, errorCallBack) {
    execute(() => fetch(groupGameByIdUrl + gameId + "/card", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function getCurrentGroupGameStyle(gameId, successCallBack, errorCallBack) {
    execute(() => fetch(groupGameByIdUrl + gameId + "/field_style", {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
    }), successCallBack, errorCallBack)
}

export function getCardDescription(gameId, cellNumber, successCallBack, errorCallBack) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
    execute(() => fetch(groupGameByIdUrl + gameId + "/card/" + cellNumber, {
        method: 'GET',
        headers: headers,
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function postDiceMove(gameId, playerId, diceNum, successCallBack, errorCallBack) {
    execute(() => fetch(`${groupGameByIdUrl}${gameId}/player/${playerId}/move`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            dice_num: diceNum,
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function deleteLastMove(gameId, playerId, successCallBack, errorCallBack) {
    execute(() => fetch(`${groupGameByIdUrl}${gameId}/player/${playerId}/last_step`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function deleteLastPendingMove(gameId, playerId, successCallBack, errorCallBack) {
    execute(() => fetch(`${groupGameByIdUrl}${gameId}/player/${playerId}/last_step?pending_move=true`, {
        method: 'DELETE',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function postStepComment(gameId, stepId, text, successCallBack, errorCallBack) {
    execute(() => fetch(`${groupGameByIdUrl}${gameId}/step/${stepId}/comment`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            text: text,
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function postPlayerRequest(gameId, playerId, playerRequestText, successCallBack, errorCallBack) {
    execute(() => fetch(`${groupGameByIdUrl}${gameId}/player/${playerId}/user_request`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            user_request: playerRequestText,
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function callContinueEndedGame(gameId, playerId, successCallBack, errorCallBack) {
    execute(() => fetch(`${groupGameByIdUrl}${gameId}/player/${playerId}/continue_ended`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },

        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function callConvertTrialGameToRegular(gameId, perserveHistory, successCallBack, errorCallBack) {
    execute(() => fetch(`${groupGameByIdUrl}${gameId}/convert_trial`, {
        method: 'POST',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            preserve_history: perserveHistory
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function getZoomAuthToken(game_id, successCallBack, errorCallBack) {
    execute(
        () => fetch(groupGameByIdUrl + game_id + "/zoomauthtoken", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: "include"
        }), successCallBack, errorCallBack
    )
}

export function saveSelectedMetaphoricCard(gameId, playerId, selectedStack, cardNumber, ingUrl, successCallBack, errorCallBack) {
    execute(
        () => fetch(`${groupGameByIdUrl}${gameId}/player/${playerId}/metaphoric_card`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                deck: selectedStack,
                card: cardNumber,
                image_url: ingUrl,
            }),
            credentials: "include"
        }), successCallBack, errorCallBack
    )
}

export function sendRecordingStartedUpdate(gameId, successCallBack, errorCallBack) {
    execute(() => fetch(groupGameByIdUrl + gameId + "/recording_started", {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
    }), successCallBack, errorCallBack)
}

export function getPresignedS3Request(gameId, successCallBack, errorCallBack) {
    execute(() => fetch(groupGameByIdUrl + gameId + "/presigneduploadrequest", {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        },
    }), successCallBack, errorCallBack)
}

export function getLiveKitToken(gameId, playerId, playerName, successCallBack, errorCallBack) {
    execute(() => fetch(groupGameByIdUrl + gameId + "/livekitauthtoken", {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            player_id: playerId,
            player_name: playerName
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function changeVideoType(gameId, successCallBack, errorCallBack) {
    execute(() => fetch(groupGameByIdUrl + gameId + "/changevideotype", {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function addCustomMove(gameId, playerId, toPosition, successCallBack, errorCallBack) {
    execute(() => fetch(`${groupGameByIdUrl}${gameId}/player/${playerId}/custom_move`, {
        method: "POST",
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({
            to_position: toPosition
        }),
        credentials: "include"
    }), successCallBack, errorCallBack)
}

export function getCurrentGameCached(game_id, player_id, successCallBack, errorRedirect) {
    let url = cachedGameUrl + game_id
    if (player_id) {
        url += `?player=${player_id}`
    }

    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }

    execute(() => fetch(url, {
        method: 'GET',
        headers: headers,
        credentials: "include"
    }), successCallBack, errorRedirect)
}

export function setUserGroupGameViewSettings(game_id, player_id, highlight, allowView, successCallBack, errorRedirect) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
    const payload = {}

    if (highlight === true || highlight === false) {
        payload.game_view_highlight_steps = highlight
    }

    if (allowView === true || allowView === false) {
        payload.game_view_enable_view_all_cells = allowView
    }


    execute(() => fetch(groupGameByIdUrl + game_id + "/player/" + player_id + "/user_game_settings", {
        method: 'POST',
        headers: headers,
        credentials: "include",
        body: JSON.stringify(payload)
    }), successCallBack, errorRedirect)
}

export function changeDiceType(game_id, player_id, successCallBack, errorRedirect) {
    const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    }
    const payload = {}
    execute(() => fetch(groupGameByIdUrl + game_id + "/player/" + player_id + "/dice_type", {
        method: 'POST',
        headers: headers,
        credentials: "include",
        body: JSON.stringify(payload)
    }), successCallBack, errorRedirect)
}
